import React__default from 'react';
import { IconSize, Palette } from '../../lib/constants.js';
import 'classnames';
import '../../UIElements/AllCategoriesModal/config.js';
import '@sbt-web/network/types';
import '../../UIElements/AllCategoriesModal/categories.js';
import '@sbt-web/category-utils';
import '../../UIElements/Badge/index.js';
import 'radix-ui';
import { Icon as IconMemo } from '../../UIElements/Icon/index.js';
import '../../UIElements/Button/index.js';
import '../../UIElements/ButtonLink/index.js';
import '../../UIElements/Chip/index.js';
import '../../UIElements/Divider/index.js';
import '../../UIElements/ListItem/ItemRadio/index.js';
import '../../UIElements/ListItem/ItemCheckBox/index.js';
import '../../UIElements/Loader/index.js';
import '../../UIElements/Notifications/NotificationsContainer/index.js';
import '../../UIElements/StaticChip/StaticChip.js';
import '../../UIElements/TextLink/index.js';
import '../../Icons/ArrowDown/index.js';
import '../../Icons/Camera/index.js';
import '../../Icons/Category/index.js';
import '../../Icons/CheckCircle/index.js';
import '../../Icons/Close/index.js';
import '../../Icons/Favorite/index.js';
import '../../Icons/Lens/index.js';
import '../../Icons/LensHeart/index.js';
import '../../Icons/Phone/index.js';
import '../../Icons/Pin/index.js';
import '../../Icons/Promo/index.js';
import '../../Icons/Share/index.js';
import '../../Icons/Bell/index.js';
import '../../Icons/Bin/index.js';
import '../../Icons/Check/index.js';
import '../../Icons/TriangleExclamation/index.js';
import '../../Icons/ShoppingBag/index.js';
import '../../UIElements/Pagination/index.js';
import classes from './index.module.scss.js';

const Seal = ({ children }) => (React__default.createElement("div", { className: classes.seal },
    React__default.createElement(IconMemo, { name: "Check", iconSize: IconSize.MD, fillColor: Palette.GreenLavoro }),
    React__default.createElement("p", { className: "body-text" }, children)));

export { Seal };
//# sourceMappingURL=index.js.map
